/**
 * ========================================
 * 模态框组件 - 现代化设计
 * ========================================
 * 
 * 功能：
 * - 支持多层模态框堆叠
 * - 支持点击遮罩关闭（可配置）
 * - 支持ESC键关闭
 * - 支持Bootstrap 5语法兼容
 * - 优雅的动画效果
 * - 自动管理滚动锁定
 * 
 * 用法：
 * $(modalElement).modal('show')  // 显示模态框
 * $(modalElement).modal('hide')  // 隐藏模态框
 * 
 * 属性：
 * data-backdrop-close="false"    // 禁止点击遮罩关闭
 * data-bs-toggle="modal"         // 自动绑定触发器
 * data-bs-target="#modalId"      // 指定目标模态框
 * 
 * 事件：
 * show.bs.modal    // 模态框即将显示
 * shown.bs.modal   // 模态框已显示
 * hide.bs.modal    // 模态框即将隐藏
 * hidden.bs.modal  // 模态框已隐藏
 */

(function($){
    // 全局状态管理
    let openModals = []; // 模态框栈
    const ANIMATION_DURATION = 380; // 与CSS动画时长一致
    
    /**
     * 触发模态框事件
     * @param {jQuery} $modal - 模态框jQuery对象
     * @param {string} eventName - 事件名称
     * @returns {boolean} - 是否继续执行（事件未被阻止）
     */
    function triggerModalEvent($modal, eventName) {
        const event = $.Event(eventName);
        $modal.trigger(event);
        return !event.isDefaultPrevented();
    }
    
    /**
     * 为模态框创建独立的遮罩层（Bootstrap标准）
     * @param {number} stackIndex - 堆叠索引
     * @returns {jQuery} - 遮罩层jQuery对象
     */
    function createBackdrop(stackIndex) {
        const backdrop = $('<div class="modal-backdrop fade"></div>');
        backdrop.attr('data-modal-index', stackIndex);
        backdrop.css('--modal-stack-index', stackIndex);
        backdrop.appendTo('body');
        return backdrop;
    }
    
    /**
     * 获取模态框配置
     * @param {jQuery} $modal - 模态框jQuery对象
     * @returns {object} - 配置对象
     */
    function getModalConfig($modal) {
        const attrVal = $modal.attr('data-backdrop-close');
        return {
            allowBackdropClose: attrVal === undefined || attrVal === null ? true : !(attrVal === 'false' || attrVal === false)
        };
    }
    
    /**
     * 显示模态框
     * @param {jQuery} $modal - 模态框jQuery对象
     */
    function showModal($modal) {
        // 触发show事件，如果被阻止则不继续
        if (!triggerModalEvent($modal, 'show.bs.modal')) return;
        
        // 保存原始位置信息（用于恢复）
        if (!$modal.data('ui-modal-original-parent')) {
            $modal.data('ui-modal-original-parent', $modal.parent());
            $modal.data('ui-modal-original-next', $modal.next());
        }
        
        // 计算当前堆叠索引
        const stackIndex = openModals.length;
        
        // 为此模态框创建独立的遮罩层
        const backdrop = createBackdrop(stackIndex);
        $modal.data('ui-modal-backdrop', backdrop);
        
        // 设置模态框的堆叠索引
        $modal.attr('data-modal-index', stackIndex);
        $modal.css('--modal-stack-index', stackIndex);
        
        // 添加到模态框栈
        openModals.push($modal);
        
        // 将模态框保持在body中（不移动到backdrop内）
        if ($modal.parent()[0] !== document.body) {
            $modal.appendTo('body');
        }
        
        // 显示遮罩层（Bootstrap标准方式）
        backdrop.css('display', 'block');
        void backdrop[0].offsetWidth; // 触发重排
        backdrop.addClass('show');
        
        // 显示模态框（使用Bootstrap标准类名）
        // 如果没有fade类，添加它以启用动画
        if (!$modal.hasClass('fade')) {
            $modal.addClass('fade');
        }
        
        // 触发重排，然后添加show类启动动画
        $modal.css('display', 'block');
        void $modal[0].offsetWidth;
        $modal.addClass('show');
        
        // 锁定页面滚动（Bootstrap标准类名）
        $('body').addClass('modal-open');
        
        // 绑定ESC键关闭（仅关闭栈顶模态框）
        $(document).off('keydown.ui.modal').on('keydown.ui.modal', function(e){
            if(e.key === "Escape" && openModals.length) {
                const topModal = openModals[openModals.length - 1];
                topModal.modal('hide');
            }
        });
        
        // 绑定遮罩点击事件（点击backdrop关闭对应的模态框）
        const config = getModalConfig($modal);
        backdrop.off('click.ui.modal').on('click.ui.modal', function(e){
            // 确保点击的是遮罩本身，而不是模态框内容
            if (e.target === this) {
                if (config.allowBackdropClose) {
                    $modal.modal('hide');
                }
            }
        });
        
        // 同时为modal元素本身绑定点击事件（Bootstrap标准行为）
        $modal.off('click.ui.modal-self').on('click.ui.modal-self', function(e){
            // 只有当点击的是modal容器本身（不是modal-dialog或其子元素）时才关闭
            if (e.target === this && config.allowBackdropClose) {
                $modal.modal('hide');
            }
        });
        
        // 设置cursor样式和data属性
        if (!config.allowBackdropClose) {
            backdrop.css('cursor', 'not-allowed');
            backdrop.attr('data-backdrop-static', 'true');
            // modal容器本身也设置禁止鼠标，但内容区域会覆盖
            $modal.css('cursor', 'not-allowed');
        } else {
            backdrop.css('cursor', 'pointer');
            backdrop.removeAttr('data-backdrop-static');
            $modal.css('cursor', 'auto');
        }
        
        // 绑定模态框内的关闭按钮
        $modal.find('[data-dismiss="modal"], [data-bs-dismiss="modal"], .close, .btn-close')
            .off('click.ui.modal')
            .on('click.ui.modal', function(e){
                e.preventDefault();
                $modal.modal('hide');
            });
        
        // 触发shown事件
        setTimeout(function(){
            triggerModalEvent($modal, 'shown.bs.modal');
        }, 0);
    }
    
    /**
     * 隐藏模态框
     * @param {jQuery} $modal - 模态框jQuery对象
     */
    function hideModal($modal) {
        // 触发hide事件，如果被阻止则不继续
        if (!triggerModalEvent($modal, 'hide.bs.modal')) return;
        
        // 移除show类启动关闭动画（Bootstrap标准）
        $modal.removeClass('show');
        
        // 获取该模态框的独立backdrop
        const backdrop = $modal.data('ui-modal-backdrop');
        
        // 从栈中移除
        const index = openModals.indexOf($modal);
        if (index > -1) {
            openModals.splice(index, 1);
        }
        
        // 【关键修复】立即检查并清理 modal-open 类，不等待动画
        // 如果没有其他打开的模态框，立即移除滚动锁定
        if (openModals.length === 0) {
            $('body').removeClass('modal-open');
            $(document).off('keydown.ui.modal');
        }
        
        // 隐藏并移除该模态框的backdrop（Bootstrap标准）
        if (backdrop) {
            backdrop.removeClass('show');
        }
        
        // 动画结束后清理DOM元素
        setTimeout(function(){
            $modal.css('display', 'none');
            $modal.removeAttr('data-modal-index');
            $modal.css('--modal-stack-index', '');
            // 保留fade类以便下次打开时有动画
            
            // 移除backdrop
            if (backdrop) {
                backdrop.remove();
                $modal.removeData('ui-modal-backdrop');
            }
            
            // 再次检查（双重保险）
            if (openModals.length === 0) {
                $('body').removeClass('modal-open');
                $(document).off('keydown.ui.modal');
            }
            
            // 解绑当前模态框的关闭按钮和点击事件
            $modal.find('[data-dismiss="modal"], [data-bs-dismiss="modal"], .close, .btn-close')
                .off('click.ui.modal');
            $modal.off('click.ui.modal-self');
            
            // 恢复模态框到原始位置
            const parent = $modal.data('ui-modal-original-parent');
            const next = $modal.data('ui-modal-original-next');
            if (parent && parent.length) {
                if (next && next.length) {
                    $modal.insertBefore(next);
                } else {
                    $modal.appendTo(parent);
                }
            }
            
            // 触发hidden事件
            triggerModalEvent($modal, 'hidden.bs.modal');
        }, ANIMATION_DURATION);
    }
    
    /**
     * jQuery插件方法
     */
    $.fn.modal = function(action){
        if(action === 'show') {
            showModal(this);
        } else if(action === 'hide') {
            hideModal(this);
        } else if(action === 'toggle') {
            if(this.hasClass('ui-modal-open')) {
                hideModal(this);
            } else {
                showModal(this);
            }
        }
        return this;
    };
    
    /**
     * 绑定单个触发器
     * @param {HTMLElement} element - 触发器元素
     */
    function bindModalTrigger(element) {
        // 防止重复绑定
        if (element.hasAttribute('data-modal-bound')) return;
        element.setAttribute('data-modal-bound', 'true');
        
        element.addEventListener('click', function(e) {
            e.preventDefault();
            const target = this.getAttribute('data-bs-target') || this.getAttribute('href');
            if (target) {
                const modal = document.querySelector(target);
                if (modal) {
                    $(modal).modal('show');
                }
            }
        });
    }
    
    /**
     * 绑定所有触发器
     */
    function bindModalTriggers() {
        document.querySelectorAll('[data-bs-toggle="modal"]').forEach(bindModalTrigger);
    }
    
    /**
     * 初始化模态框组件
     */
    function initModals() {
        // 绑定现有触发器
        bindModalTriggers();
        
        // 监听DOM变化，自动绑定新添加的触发器
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // 检查节点本身
                        if (node.matches && node.matches('[data-bs-toggle="modal"]')) {
                            bindModalTrigger(node);
                        }
                        // 检查子节点
                        if (node.querySelectorAll) {
                            const triggers = node.querySelectorAll('[data-bs-toggle="modal"]');
                            triggers.forEach(bindModalTrigger);
                        }
                    }
                });
            });
        });
        
        observer.observe(document.body, { 
            childList: true, 
            subtree: true 
        });
    }
    
    /**
     * 插入基础样式（确保基本功能可用）
     */
    function insertBaseStyles() {
        if (!document.getElementById('ui-modal-style')) {
            const style = document.createElement('style');
            style.id = 'ui-modal-style';
            style.textContent = `
                .ui-modal-backdrop {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    z-index: 1040;
                    display: none;
                }
                .ui-modal-open {
                    z-index: 1050;
                    display: block;
                }
                .ui-modal-noscroll {
                    overflow: hidden;
                }
                .ui-modal-backdrop-allow {
                    cursor: pointer;
                }
                .ui-modal-backdrop-forbid {
                    cursor: not-allowed;
                }
            `;
            document.head.appendChild(style);
        }
    }
    
    // 初始化
    insertBaseStyles();
    
    if (document.readyState === 'loading') {
        $(document).ready(initModals);
    } else {
        initModals();
    }
    
})(jQuery);


/**
 * Modal 静态类 - 提供便捷的全局调用API
 * 类似于 Toast.show() 和 Alert.info() 的使用方式
 */
class Modal {
    /**
     * 显示一个简单的消息模态框
     * @param {string} message - 消息内容
     * @param {Object} options - 配置选项
     * @param {string} options.title - 标题（默认："提示"）
     * @param {string} options.type - 类型：info/success/warning/danger（默认：info）
     * @param {string} options.size - 尺寸：sm/lg/xl/fullscreen（默认：默认尺寸）
     * @param {boolean} options.centered - 是否垂直居中（默认：true）
     * @param {string} options.confirmText - 确认按钮文本（默认："确定"）
     * @param {string} options.cancelText - 取消按钮文本（不设置则不显示取消按钮）
     * @param {Function} options.onConfirm - 确认回调
     * @param {Function} options.onCancel - 取消回调
     * @param {boolean} options.html - 内容是否为HTML（默认：false）
     * @param {boolean} options.backdrop - 是否允许点击遮罩关闭（默认：true）
     */
    static show(message, options = {}) {
        const config = {
            title: '提示',
            type: 'info',
            size: '',
            centered: true,
            confirmText: '确定',
            cancelText: '',
            onConfirm: null,
            onCancel: null,
            html: false,
            backdrop: true,
            ...options
        };

        const modalId = 'modal-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        const sizeClass = config.size ? `modal-${config.size}` : '';
        const centeredClass = config.centered ? 'modal-dialog-centered' : '';
        const typeClass = config.type !== 'info' ? `modal-${config.type}` : '';
        const backdropAttr = config.backdrop ? '' : ' data-backdrop-close="false"';

        // 类型图标映射
        const iconMap = {
            success: '✓',
            warning: '⚠',
            danger: '✕',
            info: 'ℹ'
        };

        const icon = iconMap[config.type] || iconMap.info;

        const messageContent = config.html ? message : Modal._escapeHtml(message);

        const modalHtml = `<div class="modal fade ${typeClass}" id="${modalId}" tabindex="-1"${backdropAttr}> <div class="modal-dialog ${sizeClass} ${centeredClass}"> <div class="modal-content"> <div class="modal-header"> <h5 class="modal-title">${Modal._escapeHtml(config.title)}</h5> <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="关闭">×</button> </div> <div class="modal-body"> ${config.type !== 'info' ?`<div class="modal-icon-wrapper"><span class="modal-icon">${icon}</span></div>`: ''} <div>${messageContent}</div> </div> <div class="modal-footer"> ${config.cancelText ?`<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">${Modal._escapeHtml(config.cancelText)}</button>`: ''} <button type="button" class="btn btn-${config.type === 'info' ? 'primary' : config.type}" data-modal-confirm="true">${Modal._escapeHtml(config.confirmText)}</button> </div> </div> </div> </div>`;

        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const modalElement = document.getElementById(modalId);

        // 绑定确认按钮
        const confirmBtn = modalElement.querySelector('[data-modal-confirm]');
        if (confirmBtn) {
            confirmBtn.addEventListener('click', function() {
                if (config.onConfirm) {
                    config.onConfirm();
                }
                Modal._hideAndCleanup(modalElement);
            });
        }

        // 绑定取消按钮
        if (config.cancelText) {
            const cancelBtns = modalElement.querySelectorAll('[data-bs-dismiss="modal"]');
            cancelBtns.forEach(btn => {
                btn.addEventListener('click', function() {
                    if (config.onCancel) {
                        config.onCancel();
                    }
                });
            });
        }

        // 显示模态框
        Modal._showModal(modalElement);

        return modalElement;
    }

    /**
     * 显示成功消息模态框
     */
    static success(message, options = {}) {
        return Modal.show(message, { ...options, type: 'success', title: options.title || '成功' });
    }

    /**
     * 显示错误消息模态框
     */
    static error(message, options = {}) {
        return Modal.show(message, { ...options, type: 'danger', title: options.title || '错误' });
    }

    /**
     * 显示警告消息模态框
     */
    static warning(message, options = {}) {
        return Modal.show(message, { ...options, type: 'warning', title: options.title || '警告' });
    }

    /**
     * 显示信息消息模态框
     */
    static info(message, options = {}) {
        return Modal.show(message, { ...options, type: 'info', title: options.title || '提示' });
    }

    /**
     * 显示确认对话框
     */
    static confirm(message, options = {}) {
        const config = {
            title: '确认操作',
            cancelText: '取消',
            confirmText: '确定',
            type: 'warning',
            ...options
        };
        return Modal.show(message, config);
    }

    /**
     * 显示自定义HTML内容的模态框
     */
    static html(htmlContent, options = {}) {
        return Modal.show(htmlContent, { ...options, html: true });
    }

    /**
     * 创建完全自定义的模态框（通用API）
     * @param {string} modalHtml - 完整的模态框HTML（包含.modal元素）
     * @param {object} options - 配置选项
     * @param {boolean} options.autoCleanup - 关闭后是否自动清理DOM（默认true）
     * @param {function} options.onShow - 显示后的回调
     * @param {function} options.onHide - 隐藏后的回调
     * @returns {HTMLElement} 模态框元素
     */
    static create(modalHtml, options = {}) {
        const config = {
            autoCleanup: true,
            onShow: null,
            onHide: null,
            ...options
        };

        // 插入到DOM
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        
        // 获取刚插入的模态框元素（假设是最后一个.modal）
        const allModals = document.querySelectorAll('.modal');
        const modalElement = allModals[allModals.length - 1];

        if (!modalElement) {
            console.error('Modal.create: 未找到有效的模态框元素');
            return null;
        }

        // 自动清理
        if (config.autoCleanup) {
            if (window.jQuery && typeof window.jQuery.fn.modal === 'function') {
                window.jQuery(modalElement).on('hidden.bs.modal', function() {
                    if (config.onHide) config.onHide(modalElement);
                    modalElement.remove();
                });
            } else if (window.bootstrap && window.bootstrap.Modal) {
                modalElement.addEventListener('hidden.bs.modal', function() {
                    if (config.onHide) config.onHide(modalElement);
                    modalElement.remove();
                });
            }
        }

        // 显示模态框
        Modal._showModal(modalElement);

        // 显示后回调
        if (config.onShow) {
            if (window.jQuery && typeof window.jQuery.fn.modal === 'function') {
                window.jQuery(modalElement).on('shown.bs.modal', function() {
                    config.onShow(modalElement);
                });
            } else if (window.bootstrap && window.bootstrap.Modal) {
                modalElement.addEventListener('shown.bs.modal', function() {
                    config.onShow(modalElement);
                });
            } else {
                setTimeout(() => config.onShow(modalElement), 100);
            }
        }

        return modalElement;
    }

    /**
     * 创建并显示表单模态框
     */
    static form(formHtml, options = {}) {
        const config = {
            title: '表单',
            confirmText: '提交',
            cancelText: '取消',
            onConfirm: null,
            onCancel: null,
            size: '',
            centered: true,
            ...options
        };

        const modalId = 'modal-form-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        const sizeClass = config.size ? `modal-${config.size}` : '';
        const centeredClass = config.centered ? 'modal-dialog-centered' : '';

        const modalHtml = `<div class="modal fade" id="${modalId}" tabindex="-1"> <div class="modal-dialog ${sizeClass} ${centeredClass}"> <div class="modal-content"> <div class="modal-header"> <h5 class="modal-title">${Modal._escapeHtml(config.title)}</h5> <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="关闭">×</button> </div> <div class="modal-body"> ${formHtml} </div> <div class="modal-footer"> <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">${Modal._escapeHtml(config.cancelText)}</button> <button type="button" class="btn btn-primary" data-modal-confirm="true">${Modal._escapeHtml(config.confirmText)}</button> </div> </div> </div> </div>`;

        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const modalElement = document.getElementById(modalId);

        // 绑定确认按钮 - 传递表单数据
        const confirmBtn = modalElement.querySelector('[data-modal-confirm]');
        if (confirmBtn) {
            confirmBtn.addEventListener('click', function() {
                const formElement = modalElement.querySelector('form');
                if (config.onConfirm) {
                    // 收集表单数据
                    const formData = formElement ? new FormData(formElement) : null;
                    // 注意：onConfirm 中需要手动调用 Modal.hide() 来关闭模态框
                    // 如果验证失败，不调用 Modal.hide() 即可保持打开状态
                    config.onConfirm(formData, modalElement);
                } else {
                    Modal._hideAndCleanup(modalElement);
                }
            });
        }

        // 绑定取消和关闭按钮
        const dismissBtns = modalElement.querySelectorAll('[data-bs-dismiss="modal"]');
        dismissBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                if (config.onCancel) {
                    config.onCancel();
                }
                Modal._hideAndCleanup(modalElement);
            });
        });

        Modal._showModal(modalElement);

        return modalElement;
    }

    /**
     * 关闭指定模态框
     */
    static hide(modalElement) {
        if (typeof modalElement === 'string') {
            modalElement = document.querySelector(modalElement);
        }
        if (modalElement) {
            Modal._hideAndCleanup(modalElement);
        }
    }

    /**
     * 关闭所有模态框
     */
    static hideAll() {
        const modals = document.querySelectorAll('.modal.show');
        modals.forEach(modal => Modal._hideAndCleanup(modal));
    }

    // ========== 内部辅助方法 ==========

    static _showModal(modalElement) {
        const backdropClose = modalElement.getAttribute('data-backdrop-close') !== 'false';
        
        if (window.jQuery && typeof window.jQuery.fn.modal === 'function') {
            window.jQuery(modalElement).modal('show');
            
            // 为jQuery模态框添加backdrop点击事件
            if (backdropClose) {
                // 等待backdrop创建后绑定事件
                setTimeout(() => {
                    const backdrop = window.jQuery(modalElement).data('ui-modal-backdrop');
                    if (backdrop) {
                        backdrop.off('click.static-modal').on('click.static-modal', function(e) {
                            // 确保点击的是遮罩本身
                            if (e.target === this) {
                                Modal._hideAndCleanup(modalElement);
                            }
                        });
                    }
                }, 50);
            } else {
                // 添加禁止鼠标样式和data属性
                setTimeout(() => {
                    const backdrop = window.jQuery(modalElement).data('ui-modal-backdrop');
                    if (backdrop) {
                        backdrop.css('cursor', 'not-allowed');
                        backdrop.attr('data-backdrop-static', 'true');
                    }
                }, 50);
            }
        } else if (window.bootstrap && window.bootstrap.Modal) {
            const bsModal = new window.bootstrap.Modal(modalElement, {
                backdrop: backdropClose ? true : 'static' // static表示点击不关闭
            });
            bsModal.show();
            
            // Bootstrap的static backdrop会自动处理点击，但我们需要添加禁止鼠标样式
            if (!backdropClose) {
                setTimeout(() => {
                    const backdrop = document.querySelector('.modal-backdrop.show');
                    if (backdrop) {
                        backdrop.style.cursor = 'not-allowed';
                        backdrop.setAttribute('data-backdrop-static', 'true');
                    }
                }, 50);
            }
        } else {
            // Fallback
            modalElement.style.display = 'block';
            modalElement.classList.add('show');
            
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            document.body.appendChild(backdrop);
            document.body.classList.add('modal-open');
            
            modalElement._backdrop = backdrop;

            const closeBtns = modalElement.querySelectorAll('[data-bs-dismiss="modal"], .btn-close');
            closeBtns.forEach(btn => {
                btn.addEventListener('click', () => Modal._hideAndCleanup(modalElement));
            });

            // 点击遮罩关闭
            const backdropClose = modalElement.getAttribute('data-backdrop-close') !== 'false';
            if (backdropClose) {
                backdrop.addEventListener('click', (e) => {
                    // 确保点击的是遮罩本身
                    if (e.target === backdrop) {
                        Modal._hideAndCleanup(modalElement);
                    }
                });
                backdrop.style.cursor = 'pointer';
            } else {
                backdrop.style.cursor = 'not-allowed';
                backdrop.setAttribute('data-backdrop-static', 'true');
            }
        }
    }

    static _hideAndCleanup(modalElement) {
        // 【关键修复】立即检查并清理 modal-open，不等待动画或事件
        const checkAndCleanup = () => {
            // 立即检查剩余模态框（不包括当前正在关闭的）
            const remainingModals = Array.from(document.querySelectorAll('.modal.show'))
                .filter(m => m !== modalElement);
            
            if (remainingModals.length === 0) {
                document.body.classList.remove('modal-open');
                // 清理可能残留的backdrop
                const backdrops = document.querySelectorAll('.modal-backdrop');
                backdrops.forEach(b => {
                    // 不移除可能属于其他模态框的backdrop
                    if (!b.hasAttribute('data-modal-index') || 
                        b.getAttribute('data-modal-index') === modalElement.getAttribute('data-modal-index')) {
                        b.remove();
                    }
                });
            }
        };
        
        // 延迟安全检查（多重保险）
        const safetyCheck = () => {
            setTimeout(() => {
                const stillVisible = document.querySelectorAll('.modal.show');
                if (stillVisible.length === 0) {
                    document.body.classList.remove('modal-open');
                }
            }, 100);
        };
        
        if (window.jQuery && typeof window.jQuery.fn.modal === 'function') {
            // 立即清理
            checkAndCleanup();
            window.jQuery(modalElement).modal('hide');
            // 动画完成后再次确认
            window.jQuery(modalElement).one('hidden.bs.modal', function() {
                checkAndCleanup();
                safetyCheck(); // 额外的安全检查
            });
        } else if (window.bootstrap && window.bootstrap.Modal) {
            const bsModal = window.bootstrap.Modal.getInstance(modalElement);
            if (bsModal) {
                // 立即清理
                checkAndCleanup();
                bsModal.hide();
                // 动画完成后再次确认
                modalElement.addEventListener('hidden.bs.modal', function handler() {
                    modalElement.removeEventListener('hidden.bs.modal', handler);
                    checkAndCleanup();
                    safetyCheck(); // 额外的安全检查
                }, { once: true });
            }
        } else {
            // Fallback 方式
            modalElement.style.display = 'none';
            modalElement.classList.remove('show');
            
            // 移除backdrop
            if (modalElement._backdrop) {
                modalElement._backdrop.remove();
                delete modalElement._backdrop;
            }
            
            // 立即清理
            checkAndCleanup();
            safetyCheck(); // 额外的安全检查
        }
        
        // 延迟移除元素
        setTimeout(() => {
            if (modalElement && modalElement.parentNode) {
                modalElement.remove();
            }
        }, 300);
    }

    static _escapeHtml(str) {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }
}

// 暴露到全局
if (typeof window !== 'undefined') {
    window.Modal = window.Modal || Modal;
    globalThis.Modal = globalThis.Modal || Modal;

    // 轻量级 iui 兼容入口，便于统一调用风格：IUI.modal.*
    const iui = window.IUI || {};
    iui.modal = iui.modal || {
        open(target) {
            const modalElement = typeof target === 'string' ? document.querySelector(target) : target;
            if (!modalElement) return false;
            Modal._showModal(modalElement);
            return true;
        },
        close(target) {
            const modalElement = typeof target === 'string' ? document.querySelector(target) : target;
            if (!modalElement) return false;
            Modal.hide(modalElement);
            return true;
        },
        closeAll() {
            Modal.hideAll();
        },
        show(message, options = {}) {
            return Modal.show(message, options);
        },
        info(message, options = {}) {
            return Modal.info(message, options);
        },
        success(message, options = {}) {
            return Modal.success(message, options);
        },
        warning(message, options = {}) {
            return Modal.warning(message, options);
        },
        error(message, options = {}) {
            return Modal.error(message, options);
        },
        confirm(message, options = {}) {
            return Modal.confirm(message, options);
        },
        html(htmlContent, options = {}) {
            return Modal.html(htmlContent, options);
        },
        form(formHtml, options = {}) {
            return Modal.form(formHtml, options);
        },
        create(modalHtml, options = {}) {
            return Modal.create(modalHtml, options);
        }
    };
    window.IUI = iui;
    globalThis.IUI = globalThis.IUI || iui;
}
